<template>
  <TheCategory :color="color" :title="title" :icon="icon" :text="text" :menu="menu" :posts="posts" />
</template>

<script>
import axios from 'axios'
import { baseApiUrl } from '@/global'

import TheCategory from '@/components/TheCategory'
export default {
  components: {
    TheCategory,
  },
  data: () => ({
    color: '#008FD2',
    title: 'Ideias',
    icon: 'lamp.png',
    text: 'Cabeça cheia, só se for de ideias. ;) Está afim de aprender algo novo? Abra um de nossos conteúdos e aproveita.',
    menu: [{ text: 'Todas' }, { text: 'Explorando' }, { text: 'Descobrindo' }, { text: 'Experimentando' }, { text: 'Escolhendo' }],
    posts: [],
  }),
  methods: {
    loadContent() {
      const url = `${baseApiUrl}/category/ideias`
      axios
        .get(url)
        .then((res) => {
          this.posts = res.data

          // if (res.data.quiz) {
          //   this.$store.dispatch("setPopupInfo", res.data.quiz);
          // }
        })
        .catch((err) => {
          if (!err.response.status === 403) {
            this.$store.dispatch('setErrorInfo', {
              open: true,
              text: 'Ops! Parece que algo deu errado. :( Talvez tenha sido um erro no link, ou alguma instabilidade no site (se for isso, já estamos resolvendo). ;) ',
            })
          }
        })
    },
  },
  mounted() {
    this.loadContent()
    localStorage.removeItem('salveProfile')
    this.$store.dispatch('setMobileRouterInfo', '/ideias')
  },
  created() {
    window.scrollTo(0, 0)
  },
}
</script>

<style></style>
